import { useEffect } from 'react';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';

/**
 * Hook to create a timer when a component mounts and clears the timer when the component unmounts
 * @param callback Function to execute on timeout
 * @param timeout Duration of the timeout
 */
export function useSafeComponentTimeout(callback: () => void, timeout: number) {
    useEffect(() => {
        let timeoutID: NodeJS.Timer;
        if (!isNullOrUndefined(timeout)) {
            timeoutID = setTimeout(() => callback && callback(), timeout);
        }

        return () => {
            timeout && clearTimeout(timeoutID);
        };
    }, []);
}
